<style lang="scss" scoped>
.slide-9 {
  background-image: url("../../../assets/module5/slide9/bg-03.jpg");
  background-position: center;
  background-size: cover;
  padding-top: 161px;
  padding-left: 141px;
  height: calc(100% - 161px);
  padding-right: 50px;
  display: flex;
}
h1 {
  font-size: 50px;
  color: #c5d43b;
  line-height: 60px;
  margin-bottom: 50px;
  &:last-of-type {
    color: #f8dc61;
  }
}
.content {
  max-width: 420px;
  margin-top: 70px;
}
.play {
  transition: all 0.2s ease-out;
  position: absolute;
  width: 400px;
  display: block;
  top: 650px;
  right: 0;
  left: 100px;
  top: 630px;
  margin: auto;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
}
video {
  position: absolute;
  margin: auto;
  top: 109px;
  right: 0;
  left: 117px;
  z-index: 9;
  width: 820px;
  height: 458px;
  outline: none !important;
  border-radius: 24px;
}

p {
  color: #ffffff;
  font-size: 34px;
  line-height: 40px;
  margin-bottom: 1.5rem;
}
</style>

<template>
  <div class="slide-9">
    <transition name="fade" appear>
      <video
        v-if="showVideo"
        :src="videoURL"
        controls
        autoplay
        ref="video"
      ></video>
    </transition>
    <div class="content">
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 8">
          <p>{{ $t("module5.slide9.paragraph") }}</p>
        </div>
      </transition>
    </div>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 8"
        src="@/assets/module5/slide9/video-03.png"
        class="chars delay-2"
      />
    </transition>
    <a href class="play" @click.prevent="playVideo(videoID)">
      <transition name="fadeUp" appear>
        <img
          class="delay-3"
          v-show="slideIndex == 8"
          src="@/assets/module2/slide5/play_button.svg"
        />
      </transition>
    </a>
  </div>
</template>

<script>
import { log } from "../../../utils/log";
import vidEnd from "../../../utils/vid";

export default {
  data() {
    return {
      showVideo: false,
      videoURL:
        window?.CF_EBOOK_VARS?.videos?.book_5_video_3?.hd_large?.url ||
        "https://player.vimeo.com/external/372856547.hd.mp4?s=a56b3c63dffc81b3772e7c41858043b50efabb6e&profile_id=174&autoplay=1",
      videoID:
        window?.CF_EBOOK_VARS?.videos?.book_5_video_3?.video_id || "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {
    playVideo(id) {
      log.videoView(id);
      this.showVideo = true;
      vidEnd(this);
    }
  }
};
</script>
